import { styled } from '@mui/system';

export const ChartSection = styled("div")`
    // background: linear-gradient(#2372B9 0%, #378FDE 115.83%);
    .get-usage-label {
        font-size: 1rem;
        font-weight: 600;
        color: #999;
        margin-top: 15px;
    }

    .get-usage-label span {
        cursor: pointer;
        text-decoration: underline;aaaaaaa
    }
`
export const EstimateSection = styled("div")`
    display: flex;
    flex-direction: column;
    border-radius: 11px;
    background: #fff;
    border: 1px solid #c8c6c6;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.03);

    @media (max-width: 991px) {
        margin-top: 1.5rem;

        h2 {
            font-size: 1.5rem !important;
        }
    }

    h2 {
        background: #6BA543;
        border-radius: 11px 11px 0 0 ;
        padding: 14px 0;
        margin-bottom: 0;
    }
`

export const RateModule = styled("div")`
    display: flex;
    flex-direction: column;
    border-right: 1px solid #00000066;
    padding: 0 15px;

    @media (max-width: 991px) {
        border-right: none;
        padding-bottom: 15px;

        h4 {
            font-size: 1.2rem;
        }
    }
`

interface ButtonsModuleProps {
    border?:Boolean;
    order?: number;
}

export const ButtonsModule = styled("div")<ButtonsModuleProps>`
    border-right: ${({border})=> border ? '1px solid #00000066' : 'none'};
    display: flex;
    flex-direction: column;
    justify-content: ${({order})=> order === 4 ? 'flex-end' : 'space-between'};
    align-items: center;
    height: 100%;

    p {
        margin-bottom: 1rem;
        font-weight: 600;
        font-size: 1.4rem;
        color: #000; 
    }

    h4 {
        font-size: 1.8rem;
    }

    @media (max-width: 991px) {
        border-right: none;
        width:${({order})=> order === 4 ? "80%" : 'auto'};

        p {
            font-size: 1.1rem;
        }

        .MuiButtonGroup-root .MuiButtonBase-root {
            padding: 10px 5px !important;
        }

        button {
            width: 100%;
        }
    }
`